module.exports = __webpack_public_path__ + "static/assets/c0ca0dc6ae37c10c6a8431ebae08d30d.svg";